var path = 'common/download-csv/download-csv.html';
var html = "<a ng-href=\"{{vm.getCsvDownloadPath()}}\">\n    {{vm.getLinkText()}}\n</a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/common/download-csv/download-csv.html
// module id = 44
// module chunks = 0